module.exports = __webpack_public_path__ + "img/tyy_tbt828-1-1993.prt.3496463e.jpg";